import Vue from 'vue';
import imagesLoaded from 'imagesloaded';
import { gsap, Power1 } from 'gsap/all';

/**
 * Do the default transition logic.
 *
 * @param  {JSON} response
 * 
 * @return {void}
 */
export default (response, ctx, router) => {
    // Query the current situation.
    const app = document.getElementById('page-wrapper');
    const current = document.getElementById('page-container');
    current.classList.add('old-container');
    current.style.zIndex = 5;

    // Inject the new page and query it as the ajax template.
    const nextFragment = document.createRange().createContextualFragment(response.data);
    app.appendChild(nextFragment);
    const ajaxTemplate = document.querySelector('.ajax-template');

    const onBuildComplete = () => {
        
    }

    // Leave timeline onComplete callback.
    const onLeaveComplete = () => {
        // return;
        // gsap.set('.slide.active', { autoAlpha: 0, });
        // return;
        // ajaxTemplate.classList.remove('ajax-template');

        // Rebuild Vue
        router.buildPage(app, onBuildComplete);
    }

    imagesLoaded(ajaxTemplate, () => {
    // The actual leave timeline.
        const leaveTl =  gsap.timeline({ paused: true, onComplete: onLeaveComplete });
        leaveTl.to(['.slide:not(.active)', '.slide.active .slide-line', '.cta-button__detail'], { autoAlpha: 0, duration: 0.4 });

        leaveTl.play();
    });

    // Called when the new page has been build by Vue.
    // This is the moment we prepare the new page and run a enter timeline.
    EventBus.$once('page-transition-enter', () => {
        const node = document.querySelector('.old-container');
        node.parentNode.removeChild(node);

        const ajaxTemplateN = document.querySelector('.ajax-template');
        ajaxTemplateN.classList.remove('ajax-template');
        // return;

        window.scrollTo(0, 0);

        // Switch section.
        document.title = ajaxTemplate.dataset.title || document.title;
        document.body.classList.remove(router.currentSection);
        document.body.classList.add(ajaxTemplate.dataset.namespace);
        router.currentSection = ajaxTemplate.dataset.namespace;
        router.app.showFooter = ajaxTemplate.dataset.showFooter;
        router.app.darkHeader = ajaxTemplate.dataset.darkHeader;
        router.app.showNavigation = false;

        window.requestAnimationFrame(() => {
            Vue.nextTick(() => {
                const onEnterComplete = () => {
                    router.pageTransitionComplete();
                }

                onEnterComplete();
            
                // const enterTl =  gsap.timeline({ paused: true, onComplete: onEnterComplete });
                // enterTl.to('#app', 0.7, { autoAlpha: 1, ease: Power1.easeIn }, 0.4);
                // enterTl.play();
            });
        });
    });
};